import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=06eb3f98&scoped=true"
import script from "./Login.vue?vue&type=script&setup=true&lang=js"
export * from "./Login.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=06eb3f98&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eb3f98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06eb3f98')) {
      api.createRecord('06eb3f98', component.options)
    } else {
      api.reload('06eb3f98', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=06eb3f98&scoped=true", function () {
      api.rerender('06eb3f98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/access/login/components/Login.vue"
export default component.exports